import { Card } from '@etg/wings';
import { useMemo, useState } from 'react';
import { cx } from '@eti/styles';
// oxlint-disable-next-line no-restricted-imports -- TODO WEBTECH-1501: Replace old schema object types with operation-specific types.

import { cardWrapper, separator } from './styles';
import AvailabilityHeader from './AvailabilityHeader';
import AirportList from './AirportList';
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
const BoundValues = {
  Departing: 0,
  Returning: 1
};
function filterAvailabilityList(list, ...predicates) {
  return list.filter(item => predicates.every(predicate => predicate(item)));
}
const isDeparting = availability => availability.boundIndex === BoundValues.Departing;
const isReturn = availability => availability.boundIndex === BoundValues.Returning;
const isAvailable = isCardSelected => availability => isCardSelected ? availability.available : true;
const AirportAvailability = ({
  accordionData,
  className,
  isDrawerOpen,
  isMultiStop,
  isSelected,
  openDrawer,
  productData,
  testid,
  toggleAccordion
}) => {
  const [isOpen, setIsOpen] = useState(true);
  const {
    availabilityList,
    departingTitle,
    returnTitle
  } = productData.extraProps;
  const filteredList = useMemo(() => {
    if (isMultiStop) {
      return {
        departing: [],
        returning: [],
        multiStop: filterAvailabilityList(availabilityList, isAvailable(isSelected))
      };
    }
    return {
      departing: filterAvailabilityList(availabilityList, isDeparting, isAvailable(isSelected)),
      returning: filterAvailabilityList(availabilityList, isReturn, isAvailable(isSelected)),
      multiStop: []
    };
  }, [availabilityList, isSelected, isMultiStop]);
  const hideListTitle = filteredList.departing.length === 0 || filteredList.returning.length === 0 || Boolean(isMultiStop);
  const closeCard = (openStatus, cardSelected) => {
    if (cardSelected) {
      setIsOpen(!openStatus);
    }
  };
  return /*#__PURE__*/_jsxs(Card, {
    "aria-live": "polite",
    className: cx(cardWrapper, className),
    "data-testid": testid,
    children: [/*#__PURE__*/_jsx(AvailabilityHeader, {
      isOpen: isOpen,
      isSelected: isSelected,
      onClick: () => closeCard(isOpen, isSelected),
      productData: productData
    }), isOpen && /*#__PURE__*/_jsxs(_Fragment, {
      children: [isSelected && /*#__PURE__*/_jsx("hr", {
        className: separator,
        "data-testid": "separator",
        role: "presentation"
      }), isMultiStop && /*#__PURE__*/_jsx(AirportList, {
        accordionData: accordionData,
        availabilityList: filteredList.multiStop,
        hideTitle: hideListTitle,
        isDrawerOpen: isDrawerOpen,
        isSelected: isSelected,
        listTitle: departingTitle,
        openDrawer: openDrawer,
        productData: productData,
        testId: "multi-stop-availability-list",
        toggleAccordion: toggleAccordion
      }), !isMultiStop && /*#__PURE__*/_jsxs(_Fragment, {
        children: [/*#__PURE__*/_jsx(AirportList, {
          accordionData: accordionData,
          availabilityList: filteredList.departing,
          hideTitle: hideListTitle,
          isDrawerOpen: isDrawerOpen,
          isSelected: isSelected,
          listTitle: departingTitle,
          openDrawer: openDrawer,
          productData: productData,
          testId: "depart-availability-list",
          toggleAccordion: toggleAccordion
        }), /*#__PURE__*/_jsx(AirportList, {
          accordionData: accordionData,
          availabilityList: filteredList.returning,
          hideTitle: hideListTitle,
          isDrawerOpen: isDrawerOpen,
          isSelected: isSelected,
          listTitle: returnTitle,
          openDrawer: openDrawer,
          productData: productData,
          testId: "return-availability-list",
          toggleAccordion: toggleAccordion
        })]
      })]
    })]
  });
};
export default AirportAvailability;
//# sourceMappingURL=AirportAvailability.js.map